/// <amd-module name="Run/Extensions/Components/LegacySection" />
import * as React from "react";


import { BuildCallbackType, IBuildResultsViewExtensionConfig } from "Build/Common/Library/ContributedExtension.types";

import { Build } from 'Build/Client/Contracts/Build';

import { LegacyComponent } from "VSS/Legacy/Legacy";
import { Card } from "VSSUI/Card";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface IContribution {
    id: string;
    name: string;
    properties: any;
}

interface ILegacySectionProps {
    build: Build;
    contributions: IContribution[];
}

export function LegacySection(props: ILegacySectionProps) {
    const buildCallBacks: BuildCallbackType[] = [];
    const [contributions, setContributions] = React.useState([] as IContribution[]);
    React.useEffect(() => {
        setContributions(props.contributions);
    }, [props.contributions]);

    React.useEffect(() => {
        buildCallBacks.forEach(x => x(props.build));
    }, [props.build]);

    const legacyNoop = (args: any) => {
        console.error("Not supported");
    }

    const onBuildChanged = (x: BuildCallbackType) => {
        buildCallBacks.push(x);
        x(props.build);
    }

    return <div>
        {
            contributions.map(contribution => {
                const context: IBuildResultsViewExtensionConfig = {
                    onBuildChanged: onBuildChanged,
                    onViewDisplayed: legacyNoop,
                    selectTab: legacyNoop,
                    setSectionVisibility: legacyNoop
                };

                return <Card
                    key={contribution.id}
                    className="build-ext-card">
                    <div>
                        <h3 className="body-xl">
                            {contribution.name}
                        </h3>
                        {
                            <LegacyComponent
                                modules={["Build/Scripts/LoadSecuredKnockout", "VSSPreview/Providers/ContentHost"]}
                                wrappedType="vssLegacyContributionContentHost"
                                wrappedProps={{
                                    className: "content body-m",
                                    context: context,
                                    contribution: contribution.id
                                }}
                                expectRegisteredInstance={true}
                            />
                        }
                    </div>
                </Card>;
            })
        }
    </div>;
}


